import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { useScreenSize } from '../../../hooks/index';
import { WorkspacesSidebar } from './components/workspaces-sidebar';

export const WorkspacesLayout: FC = () => {
  // Not rendered rather than hidden: a hidden tree would still load every level the selection opens.
  const { isMobile } = useScreenSize();

  return (
    <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden lg:flex-row lg:py-4 lg:pl-4 lg:pr-0">
      {!isMobile && <WorkspacesSidebar />}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};
